<h1 class="mb-4"><mdb-icon fas icon="cog"></mdb-icon> Vendedores por Familia</h1>
<!-- Heading -->
<div class="card card-miga-pan mb-2 wow">
  <!--Card content-->
  <div class="card-body d-sm-flex p-1 justify-content-between">
    <p class="mb-0">
      <span class="grey-text">Reportes y Consulta</span>
      <span> /</span>
      <span class="grey-text">Ventas</span>
      <span> /</span>
      <span>Vendedores por Familia</span>
    </p>
  </div>
</div>
<!-- Heading -->

<!-- Cabecera de botones -->
<form autocomplete="off" [formGroup]="formHeader">
  <div class="card mb-2 wow detalle-cliente">
    <div class="card-body justify-content-between">
      <div class="row filtros-body">
        <div class="col" style="max-width: 150px">
          <div class="md-form">
            <mdb-select [options]="optionsFiltroPor" [filterEnabled]="true" [highlightFirst]="false" placeholder="Todos"
              formControlName="tipoVista"></mdb-select>
            <label>Nivel de detalle</label>
          </div>
        </div>
        <div class="col" style="max-width: 150px">
          <div class="md-form mb-0">
            <mdb-date-picker [inline]="true" name="fechaDesde" [placeholder]="'Desde'" formControlName="fechaDesde"
              required></mdb-date-picker>
            <!-- <div
              *ngIf="formHeader.get('fechaDesde').invalid && (formHeader.get('fechaDesde').dirty || formHeader.get('fechaDesde').touched)">
              <mdb-error *ngIf="formHeader.get('fechaDesde').hasError('required')">Ingrese fecha desde </mdb-error>
            </div> -->
          </div>
        </div>
        <div class="col" style="max-width: 150px">
          <div class="md-form mb-0">
            <mdb-date-picker [inline]="true" name="fechaHasta" [placeholder]="'Hasta'" formControlName="fechaHasta"
              required></mdb-date-picker>
            <!-- <div
              *ngIf="formHeader.get('fechaHasta').invalid && (formHeader.get('fechaHasta').dirty || formHeader.get('fechaHasta').touched)">
              <mdb-error *ngIf="formHeader.get('fechaHasta').hasError('required')">Ingrese fecha hasta </mdb-error>
            </div> -->
          </div>
        </div>
        <!-- <div class="col" style="max-width: 150px">
          <div class="md-form">
            <mdb-select [options]="optionsVendedor" [multiple]="true" [filterEnabled]="true" [highlightFirst]="false"
              placeholder="Todos" formControlName="vendedores"></mdb-select>
            <label>Vendedor</label>
          </div>
        </div>
        <div class="col" style="max-width: 150px">
          <div class="md-form">
            <mdb-select [options]="optionsFamilia" [multiple]="true" [filterEnabled]="true" [highlightFirst]="false"
              placeholder="Todos" formControlName="familias"></mdb-select>
            <label>Familia</label>
          </div>
        </div> -->
        <div class="col col-filtro filtro-familia">
          <div class="md-form">
            <mdb-select 
              [options]="optionsFamilia" 
              [multiple]="true" 
              [filterEnabled]="true" 
              [highlightFirst]="false"
              placeholder="Todos" 
              formControlName="familias">
            </mdb-select>
            <label>Familia</label>
          </div>
        </div>        

        <div class="col col-filtro filtro-vendedor">
          <div class="md-form">
            <mdb-select 
              [options]="optionsVendedor" 
              [multiple]="true" 
              [filterEnabled]="true" 
              [highlightFirst]="false"
              placeholder="Todos" 
              formControlName="vendedores">
            </mdb-select>
            <label>Vendedor</label>
          </div>
        </div>           
        <div class="col">
          <div>
            <mdb-checkbox formControlName="producto_sin_sku">Incluir producto sin SKU</mdb-checkbox>
          </div>
        </div>
      </div>
    </div>

    <!-- FOOTER -->
    <div class="card-footer text-muted filtros-footer" style="border-top: 1px solid #dee2e6">
      <div></div>
      <button mdbBtn type="button" color="secondary" size="sm" mdbWavesEffect (click)="buscar(1)">
        <mdb-icon fas icon="search"></mdb-icon>
        Buscar
      </button>
    </div>
  </div>
</form>

<!-- Listado -->
<div class="card mb-2 wow">
  <div class="card-body p-1 justify-content-between">
    <div *ngIf="documento_loading" class="w-100 d-block text-center">
      <mdb-spinner *ngIf="documento_loading" spinnerColor="blue"></mdb-spinner>
    </div>

    <div class="table-responsive" *ngIf="formHeader.get('tipoVista').value === RB_TIPO_VISTA_DOCUMENTO">
      <table class="table table-striped table-hover table-sm align-middle" *ngIf="documento_listaMovimientos">
        <thead class="grey lighten-2">
          <tr>
            <th scope="col">Vendedor</th>
            <th scope="col">Familia</th>
            <th scope="col">SKU</th>
            <th scope="col">Producto</th>
            <th scope="col">Doc.</th>
            <th scope="col">RUT</th>
            <th scope="col">Cliente</th>
            <th scope="col">Can.</th>
            <th scope="col" class="text-right">Monto Neto</th>
            <th scope="col" class="text-right">Descuento</th>
            <th scope="col" class="doble-linea text-right">Total Neto</th>
            <th scope="col" class="text-center">Comuna</th>
            <th scope="col" class="text-center">Suc.</th>
            <th scope="col" class="text-center">Fecha Doc.</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td colspan="100%" style="text-align: center" *ngIf="documento_loading">
              <mdb-spinner spinnerColor="blue"></mdb-spinner>
            </td>
            <td colspan="100%" style="text-align: center"
              *ngIf="!documento_loading && documento_listaMovimientos?.length === 0">No se encontró información</td>
          </tr>
          <tr *ngFor="let mov of documento_listaMovimientos">
            <td>{{ mov.nombre }}</td>
            <td>{{ mov.familia_nombre }}</td>
            <td>{{ mov.sku }}</td>
            <td>{{ mov.producto_nombre }}</td>
            <td>{{ mov.folio }}</td>
            <td>{{ mov.rutFormato | rut }}</td>
            <td>{{ mov.cliente_proveedor_nombre }}</td>
            <td class="text-right">{{ mov.cantidad }}</td>
            <td class="text-right">{{ mov.monto_neto | numerico }}</td>
            <td class="text-right">{{ mov.descuento | numerico }}</td>
            <td class="text-right">{{ mov.neto_total | numerico }}</td>
            <td>{{ mov.nombrecomuna }}</td>
            <td>
              <span *ngIf="mov.codsuclegacy === '000'"></span>
              <span *ngIf="mov.codsuclegacy !== '000'">{{ mov.codsuclegacy }}</span>
            </td>
            <td>{{ mov.fecha_emision | fecha }}</td>
          </tr>
          <!-- TOTALES -->
        <tbody class="blue lighten-5">
          <tr>
            <td class="text-right" colspan="6"><strong>Totales</strong></td>
            <td class="text-right"><strong>Doc.</strong></td>
            <td class="text-right"><strong>Can.</strong></td>
            <td class="text-right"><strong>Monto Neto</strong></td>
            <td class="text-right"><strong>Descuento</strong></td>
            <td class="text-right"><strong>Total Neto</strong></td>
            <td class="text-right"></td>
            <td class="text-right"></td>
            <td class="text-right"></td>
          </tr>
          <tr>
            <td class="text-right" colspan="6"></td>
            <td class="text-right"><strong>{{ documento_totales.documento }}</strong></td>
            <td class="text-right"><strong>{{ documento_totales.cantidad }}</strong></td>
            <td class="text-right"><strong>$ {{ documento_totales.monto_neto | numerico }}</strong></td>
            <td class="text-right"><strong>$ {{ documento_totales.descuento | numerico }}</strong></td>
            <td class="text-right"><strong>$ {{ documento_totales.neto_total | numerico }}</strong></td>
            <td class="text-center"></td>
            <td class="text-center"></td>
            <td class="text-center"></td>
          </tr>
        </tbody>
        <app-pagination [context]="documento_paginationContext" (onPageChange)="documentoOnPageChange($event)"
          *ngIf="documento_listaMovimientos?.length > 0"></app-pagination>
      </table>
    </div>
    <div class="table-responsive" *ngIf="formHeader.get('tipoVista').value === RB_TIPO_VISTA_FAMILIA">
      <table class="table table-striped table-hover table-sm align-middle" *ngIf="familia_listaMovimientos">
        <thead class="grey lighten-2">
          <tr>
            <th scope="col">Vendedor</th>
            <th scope="col">Familia</th>
            <th scope="col" class="text-right">Can.</th>
            <th scope="col" class="text-right">Monto Neto</th>
            <th scope="col" class="text-right">Descuento</th>
            <th scope="col" class="doble-linea text-right">Total Neto</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td colspan="100%" style="text-align: center" *ngIf="familia_loading">
              <mdb-spinner spinnerColor="blue"></mdb-spinner>
            </td>
            <td colspan="100%" style="text-align: center"
              *ngIf="!familia_loading && familia_listaMovimientos?.length === 0">No se encontró información</td>
          </tr>
          <tr *ngFor="let mov of familia_listaMovimientos">
            <td>{{ mov.nombre }}</td>
            <td>{{ mov.familia_nombre }}</td>
            <td class="text-right">{{ mov.cantidad }}</td>
            <td class="text-right">{{ mov.monto_neto | numerico }}</td>
            <td class="text-right">{{ mov.descuento | numerico }}</td>
            <td class="text-right">{{ mov.neto_total | numerico }}</td>
          </tr>
          <!-- TOTALES -->
        <tbody class="blue lighten-5">
          <tr>
            <td class="text-right" colspan="2"><strong>Totales</strong></td>
            <td class="text-right"><strong>Can.</strong></td>
            <td class="text-right"><strong>Monto Neto</strong></td>
            <td class="text-right"><strong>Descuento</strong></td>
            <td class="text-right"><strong>Total Neto</strong></td>
          </tr>
          <tr>
            <td class="text-right" colspan="2"></td>
            <td class="text-right"><strong>{{ familia_totales.cantidad }}</strong></td>
            <td class="text-right"><strong>$ {{ familia_totales.monto_neto | numerico }}</strong></td>
            <td class="text-right"><strong>$ {{ familia_totales.descuento | numerico }}</strong></td>
            <td class="text-right"><strong>$ {{ familia_totales.neto_total | numerico }}</strong></td>
          </tr>
        </tbody>
        <app-pagination [context]="familia_paginationContext" (onPageChange)="familiaOnPageChange($event)"
          *ngIf="familia_listaMovimientos?.length > 0"></app-pagination>
      </table>
    </div>
    <div class="table-responsive" *ngIf="formHeader.get('tipoVista').value === RB_TIPO_VISTA_PRODUCTO">
      <table class="table table-striped table-hover table-sm align-middle" *ngIf="producto_listaMovimientos">
        <thead class="grey lighten-2">
          <tr>
            <th scope="col">Vendedor</th>
            <th scope="col">Familia</th>
            <th scope="col">SKU</th>
            <th scope="col">Producto</th>
            <th scope="col">Can.</th>
            <th scope="col" class="text-right">Monto Neto</th>
            <th scope="col" class="text-right">Descuento</th>
            <th scope="col" class="doble-linea text-right">Total Neto</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td colspan="100%" style="text-align: center" *ngIf="producto_loading">
              <mdb-spinner spinnerColor="blue"></mdb-spinner>
            </td>
            <td colspan="100%" style="text-align: center"
              *ngIf="!producto_loading && producto_listaMovimientos?.length === 0">No se encontró información</td>
          </tr>
          <tr *ngFor="let mov of producto_listaMovimientos">
            <td>{{ mov.nombre }}</td>
            <td>{{ mov.familia_nombre }}</td>
            <td>{{ mov.sku }}</td>
            <td>{{ mov.producto_nombre }}</td>
            <td class="text-right">{{ mov.cantidad }}</td>
            <td class="text-right">{{ mov.monto_neto | numerico }}</td>
            <td class="text-right">{{ mov.descuento | numerico }}</td>
            <td class="text-right">{{ mov.neto_total | numerico }}</td>
          </tr>
          <!-- TOTALES -->
        <tbody class="blue lighten-5">
          <tr>
            <td class="text-right" colspan="4"><strong>Totales</strong></td>
            <td class="text-right"><strong>Can.</strong></td>
            <td class="text-right"><strong>Monto Neto</strong></td>
            <td class="text-right"><strong>Descuento</strong></td>
            <td class="text-right"><strong>Total Neto</strong></td>
          </tr>
          <tr>
            <td class="text-right" colspan="4"></td>
            <td class="text-right"><strong>{{ producto_totales.cantidad }}</strong></td>
            <td class="text-right"><strong>$ {{ producto_totales.monto_neto | numerico }}</strong></td>
            <td class="text-right"><strong>$ {{ producto_totales.descuento | numerico }}</strong></td>
            <td class="text-right"><strong>$ {{ producto_totales.neto_total | numerico }}</strong></td>
          </tr>
        </tbody>
        <app-pagination [context]="producto_paginationContext" (onPageChange)="productoOnPageChange($event)"
          *ngIf="producto_listaMovimientos?.length > 0"></app-pagination>
      </table>
    </div>
  </div>
</div>

<div class="card mb-2 wow"
  *ngIf="formHeader.get('tipoVista').value === RB_TIPO_VISTA_DOCUMENTO && documento_listaMovimientos?.length > 0">
  <div class="card-body d-sm-flex p-1 justify-content-end">
    <button mdbBtn type="button" color="success" mdbWavesEffect class="btn"
      (click)="documentoDownloadExcelPdf('XLS')">Excel</button>
  </div>
</div>
<div class="card mb-2 wow"
  *ngIf="formHeader.get('tipoVista').value === RB_TIPO_VISTA_FAMILIA && familia_listaMovimientos?.length > 0">
  <div class="card-body d-sm-flex p-1 justify-content-end">
    <button mdbBtn type="button" color="success" mdbWavesEffect class="btn"
      (click)="familiaDownloadExcelPdf('XLS')">Excel</button>
  </div>
</div>
<div class="card mb-2 wow"
  *ngIf="formHeader.get('tipoVista').value === RB_TIPO_VISTA_PRODUCTO && producto_listaMovimientos?.length > 0">
  <div class="card-body d-sm-flex p-1 justify-content-end">
    <button mdbBtn type="button" color="success" mdbWavesEffect class="btn"
      (click)="productoDownloadExcelPdf('XLS')">Excel</button>
  </div>
</div>